import React from 'react'

const Footer = () => {
    return (
        <>
            <div className='container footer'>
                <div className='row'>
                    <div className='col-md-12'>
                        <p className='text-center'>&#169; Blogify, Created and Maintained by Manas, 2024</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
